import AssetsContext from "contexts/AssetsContext";
import { useContext } from "react";

const useAssets = () => useContext(AssetsContext);

export default useAssets;
